// @flow

export const MAX_LENGTHS = {
  phoneNumber: 12,
  code: 4,
  countryCode: 3
};
